
import React from 'react';
import { LineChart, BarChart } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SymptomTrendsChart } from './SymptomTrendsChart';
import { SymptomFrequencyChart } from './SymptomFrequencyChart';

interface VisualizationPanelProps {
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  isLoading: boolean;
  visualizationData: any[];
  selectedSymptoms: string[];
}

export const VisualizationPanel: React.FC<VisualizationPanelProps> = ({
  activeTab,
  setActiveTab,
  isLoading,
  visualizationData,
  selectedSymptoms
}) => {
  return (
    <Tabs defaultValue="trends" value={activeTab} onValueChange={setActiveTab}>
      <TabsList className="mb-4">
        <TabsTrigger value="trends" className="flex items-center gap-1">
          <LineChart size={16} />
          Trends
        </TabsTrigger>
        <TabsTrigger value="frequency" className="flex items-center gap-1">
          <BarChart size={16} />
          Frequency
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="trends" className="min-h-[400px]">
        {isLoading ? (
          <div className="flex justify-center items-center h-96">
            <div className="animate-pulse text-hormony-coral">Loading data...</div>
          </div>
        ) : visualizationData.length > 0 ? (
          <SymptomTrendsChart 
            data={visualizationData} 
            selectedSymptoms={selectedSymptoms}
          />
        ) : (
          <div className="text-center py-16 text-hormony-charcoal/70">
            <p>No symptom data found for the selected date range.</p>
            <p className="text-sm mt-2">
              Try selecting different dates or tracking more symptoms.
            </p>
          </div>
        )}
      </TabsContent>
      
      <TabsContent value="frequency" className="min-h-[400px]">
        {isLoading ? (
          <div className="flex justify-center items-center h-96">
            <div className="animate-pulse text-hormony-coral">Loading data...</div>
          </div>
        ) : visualizationData.length > 0 ? (
          <SymptomFrequencyChart 
            data={visualizationData} 
            selectedSymptoms={selectedSymptoms}
          />
        ) : (
          <div className="text-center py-16 text-hormony-charcoal/70">
            <p>No symptom data found for the selected date range.</p>
            <p className="text-sm mt-2">
              Try selecting different dates or tracking more symptoms.
            </p>
          </div>
        )}
      </TabsContent>
    </Tabs>
  );
};
